import { useState } from "react";
import type { NativeScrollEvent } from "react-native";
import { LoadMoreIndicator, ScrollView, Tabs, YStack } from "@medbillai/ui";
import { useRouter } from "@medbillai/navigation/router";
import { flaggedBillsUrl } from "@medbillai/utils/urls";
import { filterOptions } from "../utils/utils";
import { BillListItem } from "./BillListItem";
import { BillsOverviewBanner } from "./BillsOverviewBanner";
import { EmptyBillList } from "./empty-bill-list/EmptyBillList";
import type { BillsListProps } from "./List";
const isCloseToBottom = ({
  layoutMeasurement,
  contentOffset,
  contentSize
}: NativeScrollEvent) => {
  const verticalOffsetMargin = 60;
  return layoutMeasurement.height + contentOffset.y >= contentSize.height - verticalOffsetMargin;
};
export const BillsList = ({
  onTabPress,
  bills,
  insuranceLinks,
  filter,
  loading,
  fetchMore,
  currentBillId,
  flaggedBillsCount,
  endReached
}: BillsListProps) => {
  const {
    push
  } = useRouter();
  const [fetchingMore, setFetchingMore] = useState(false);
  const isEmpty = bills.length === 0;
  const handleFetchMore = async () => {
    if (!fetchingMore) {
      setFetchingMore(true);
      await fetchMore();
      setFetchingMore(false);
    }
  };
  const handleBannerPress = () => {
    push(flaggedBillsUrl());
  };
  return <ScrollView f={1} jc="flex-start" backgroundColor="$surface1" contentContainerStyle={{
    minHeight: "100%",
    flexGrow: isEmpty ? 1 : undefined
  }} overflow="scroll" scrollEventThrottle={20} stickyHeaderIndices={[0]} showsVerticalScrollIndicator={false} onScroll={({
    nativeEvent
  }) => {
    if (isCloseToBottom(nativeEvent)) {
      void handleFetchMore();
    }
  }} data-sentry-element="ScrollView" data-sentry-component="BillsList" data-sentry-source-file="BillsList.tsx">
      <Tabs flex={0} value={filter} onValueChange={onTabPress} data-sentry-element="Tabs" data-sentry-source-file="BillsList.tsx">
        <Tabs.Bar tabs={filterOptions} backgroundColor="$surface1" data-sentry-element="Tabs.Bar" data-sentry-source-file="BillsList.tsx" />
      </Tabs>

      {!loading && !isEmpty && flaggedBillsCount && flaggedBillsCount > 0 ? <BillsOverviewBanner issueOrBillCount={flaggedBillsCount} onPress={handleBannerPress} /> : null}

      {isEmpty ? <YStack f={1}>
          <EmptyBillList filter={filter} loading={loading} insuranceLinks={insuranceLinks} />
        </YStack> : bills.map((bill, idx) => {
      return <BillListItem key={bill.id} eob={bill} borderHide={idx === 0} selected={currentBillId === bill.resourceId} />;
    })}
      {isEmpty ? null : <LoadMoreIndicator fetchingMore={fetchingMore} endReached={endReached} noMoreMessage="No more bills" />}
    </ScrollView>;
};